import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import api from "../lib/api";
import TemplateRenderer from "../components/templates/TemplateRenderer";

const PublishedPage = () => {
  const { slug } = useParams();
  const [page, setPage] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    api.get(`/public/page/${slug}`)
      .then((res) => setPage(res.data))
      .catch(() => setError("Page introuvable"));
  }, [slug]);

  if (error) {
    return (
      <div className="min-h-screen bg-white flex items-center justify-center text-center px-5">
        <div data-testid="page-not-found">
          <h1 className="font-heading font-black text-5xl tracking-tighter">404</h1>
          <p className="text-gray-600 mt-3">Cette page n'existe pas ou n'est plus publiée.</p>
          <a href="/" className="text-blue-600 font-semibold mt-6 inline-block hover:underline">Retour à Le Guide des Entrepreneurs</a>
        </div>
      </div>
    );
  }

  if (!page) {
    return <div className="min-h-screen bg-white flex items-center justify-center text-gray-500">Chargement…</div>;
  }

  return <div className="font-preserve"><TemplateRenderer page={page} /></div>;
};

export default PublishedPage;
